import { render, staticRenderFns } from "./OperatoriItem.vue?vue&type=template&id=f83f2cda"
import script from "./OperatoriItem.vue?vue&type=script&lang=js"
export * from "./OperatoriItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports